import React, { useContext } from 'react';

import { useDeepEqualSelector, useQueryParam } from 'Shared/utils/hooks';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';
import QueryParamConstants from 'Shared/constants/QueryParams.constants';
import sortBy from 'lodash/sortBy';

import TeamGroupTemplate from '../TeamGroupTemplate/TeamGroupTemplate';
import GroupItem from '../GroupItem/GroupItem';
import EmptySectionState from '../EmptySectionState/EmptySectionState';
import AddGroupModalHandler from './AddGroupModalHandler/AddGroupModalHandler';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './GroupSection.scss';

type Props = {
  onCloseNavbar: Function;
};

function GroupSection({ onCloseNavbar }: Props) {
  const isExpanded = useContext(ExpandNavbarContext);
  const workspaces = useDeepEqualSelector(state => {
    const groupWorkspaces = state.workspaces.filter(({ starred, isGroup }) => !starred && isGroup);
    const resultList = [
      ...groupWorkspaces.filter(({ isTeamSync }) => isTeamSync),
      ...sortBy(
        groupWorkspaces.filter(({ isTeamSync }) => !isTeamSync),
        w => w.name.toLowerCase()
      ),
    ];
    return resultList;
  });

  const [, setAddGroupParam] = useQueryParam(QueryParamConstants.ADD_GROUP_WORKSPACE_MODAL);
  const { tr } = useTranslation();

  return (
    <div className="w-100">
      <AddGroupModalHandler onRedirectTo={() => setAddGroupParam(null)} />
      <TeamGroupTemplate
        title={
          <WpTooltip placement="top">
            <WpTooltipTrigger>
              <div className="d-flex align-items-center">{tr('perform.navigation.team_group_section.title')}</div>
            </WpTooltipTrigger>
            <WpTooltipContent>{tr('perform.navigation.team_group_section.tooltip')}</WpTooltipContent>
          </WpTooltip>
        }
        addButtonLabel={tr('perform.navigation.team_group_section.add_button_label')}
        tooltipLabel={tr('perform.navigation.team_group_section.add_button_tooltip')}
        onAddClick={() => setAddGroupParam(true)}
        onCloseNavbar={onCloseNavbar}
      >
        <div className="position-relative">
          <div>
            {workspaces.map(({ id, name, users, path, workspaceNotifications, starred }) => (
              <GroupItem
                key={id}
                workspaceId={id}
                name={name}
                users={users}
                path={path}
                onCloseNavbar={onCloseNavbar}
                showNewBadge={!workspaceNotifications?.viewedWorkspace}
                workspaceNotificationsCount={workspaceNotifications?.count}
                starred={starred}
              />
            ))}
            {Boolean(!workspaces.length) && isExpanded && (
              <EmptySectionState>{tr('perform.navigation.team_group_section.empty_state')}</EmptySectionState>
            )}
          </div>
        </div>
      </TeamGroupTemplate>
    </div>
  );
}

export default GroupSection;
